module.exports = __webpack_public_path__ + "img/ico-youtube-circle.9df6dcd7.svg";